function Button({ showButton, btnText, onClick, buttonType }) {
    const handleClick = (e) => {
        if (buttonType !== 'submit') {
            e.preventDefault();
        }
        onClick();
    };
    if (showButton) {
        return (
            <div className='mt-5 w-full'>
                <button type={buttonType} className='bg-[#1B7CED] font-inter text-base font-bold leading-6 text-center text-white rounded-[12px] px-10 py-3 w-full block' onClick={handleClick}>{btnText}</button>
            </div>
        )
    }
    return null;
}

export default Button;